// import { find, assign } from 'lodash'
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      tools = _ref.tools;
  return {
    /**
     * @description 登录
     * @param {Object} data 登录携带的信息
     */
    loadCategoryList: function loadCategoryList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/catalog/category',
        method: 'post',
        data: data
      });
    },
    loadQuestionTypeIdDict: function loadQuestionTypeIdDict() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/catalog/questionTypeIdDict',
        method: 'post',
        data: data
      });
    },
    loadGradeCascade: function loadGradeCascade() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/catalog/gradeCascade',
        method: 'post',
        data: data
      });
    },
    loadCategoryCascade: function loadCategoryCascade() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/catalog/categoryCascade',
        method: 'post',
        data: data
      });
    }
  };
});